<template lang="pug">
  .container
    .columns
      .column.is-3
        b Fecha Reg.&nbsp
        small {{ data.fechaReg}}
      .column.is-3
        b Realizó:&nbsp
        small {{ data.nombre_usuario}}
      .column.is-3
        b Revisó:&nbsp
        small {{ data.reviso }}
      .column.is-3
        b Autorizó:&nbsp
        small {{ data.autorizo }}
    .columns
      .column.is-3
        b Tarjeta:&nbsp
        small {{ tarjeta.categoria }} - {{ tarjeta.marca }} 
      .column.is-3
        b No. Tarjeta:&nbsp
        small {{ tarjeta.serie }}
    .columns
      .column.is-3
        b Importe Total:&nbsp
        small {{ data.importeTotal | currency }}
      .column.is-3
        b Kms. Recorridos:&nbsp
        small {{ data.km_total }}
      .column.is-3
        b Promedio:&nbsp
        small {{ data.promedio }}
      .column.is-3
        b Calidad:&nbsp
        small {{ data.calidad }}
    .columns
</template>

<script>
  export default {
    name: 'CardDataResumen',
    props: {
      tarjeta: {
        type: Object,
        default: () => {}
      },
      data: {
        type: Object,
        default: () => {}
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/CardDataResumen.vue